module.exports = __webpack_public_path__ + "img/UEC.21d715a2.png";